import { Option } from "@opendaw/lib-std";
import { TimeBase } from "@opendaw/lib-dsp";
import { AudioRegionBox } from "@opendaw/studio-boxes";
import { UnionBoxTypes } from "../unions";
import { RegionAdapters } from "./RegionBoxAdapter";
export var RegionOverlap;
(function (RegionOverlap) {
    const Float32RelativeEpsilon = 2 ** -23; // float32 has 23 mantissa bits
    RegionOverlap.boundaryTolerance = (value) => Math.abs(value) * Float32RelativeEpsilon + 1e-3;
    // The end of a seconds region moves with the tempo. It ends where the next region starts, never an error.
    RegionOverlap.endsAtSuccessor = (box) => box instanceof AudioRegionBox && box.timeBase.getValue() !== TimeBase.Musical;
    RegionOverlap.sortedRegions = (trackBox) => trackBox.regions.pointerHub.incoming()
        .map(({ box }) => UnionBoxTypes.asRegionBox(box))
        .sort((left, right) => left.position.getValue() - right.position.getValue());
    RegionOverlap.find = (sorted) => {
        for (let index = 1; index < sorted.length; index++) {
            const prev = sorted[index - 1];
            if (RegionOverlap.endsAtSuccessor(prev)) {
                continue;
            }
            const position = sorted[index].position.getValue();
            if (prev.position.getValue() + prev.duration.getValue() > position + RegionOverlap.boundaryTolerance(position)) {
                return Option.wrap(index);
            }
        }
        return Option.None;
    };
    RegionOverlap.hasSpace = (boxAdapters, trackBox, position, complete) => trackBox.regions.pointerHub.incoming().every(({ box }) => {
        const region = RegionAdapters.for(boxAdapters, box);
        return region.resolveComplete(region.position) <= position || region.position >= complete;
    });
})(RegionOverlap || (RegionOverlap = {}));
